import Block from './Block';
import gsap from 'gsap';

export default class TextImageLinks extends Block {
  getElems() {
    this.content = this.el.querySelector('.b-text-image-links__content');
    this.contentLinks = Array.from(
      this.el.querySelectorAll('.b-text-image-links__content__links a')
    );
    this.contentImages = Array.from(
      this.el.querySelectorAll('.b-text-image-links__content__images .image')
    );
    this.contentTitle = Array.from(
      this.el.querySelectorAll('.b-text-image-links__content__titles .title')
    );
    this.contentText = Array.from(
      this.el.querySelectorAll('.b-text-image-links__content__titles .text')
    );
  }

  init() {
    this.isSmallScreen = window.innerWidth <= 768;

    if (this.isSmallScreen) {
      this._enableTimeline();
    }

    window.addEventListener('resize', this._handleResize.bind(this));
  }

  _handleResize() {
    const wasSmallScreen = this.isSmallScreen;

    this.isSmallScreen = window.innerWidth <= 768;

    if (this.isSmallScreen && !wasSmallScreen) {
      // Active la timeline si on passe en petit écran
      this._enableTimeline();
    } else if (!this.isSmallScreen && wasSmallScreen) {
      // Désactive la timeline si on passe en grand écran
      this._disableTimeline();
    }
  }

  _enableTimeline() {
    this._tlContent();
    this._autoSwitch();
    this.events();
  }

  _disableTimeline() {
    // Stoppe toutes les animations et réinitialise les styles
    gsap.killTweensOf(this.content);
    if (this.contentImages) {
      this.contentImages.forEach((image) => {
        image.style.opacity = ''
      })
    }
    if (this.contentTitle) {
      this.contentTitle.forEach((title) => {
        title.style.display = ''
      })
    }
    if (this.contentText) {
      this.contentText.forEach((text) => {
        text.style.display = ''
      })
    }
  }

  _tlContent() {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.el,
        scrub: true,
        start: 'top bottom',
        end: 'top top'
      }
    });

    tl.to(this.content, {
      xPercent: 0
    });
  }

  _autoSwitch() {
    if (
      !this.contentLinks ||
      !this.contentImages ||
      !this.contentTitle ||
      !this.contentText
    ) return;

    // Durée en secondes pour chaque élément
    const duration = 3;
    // Répétition infinie
    const tl = gsap.timeline({ repeat: -1 });

    this.contentLinks.forEach((_, index) => {
      // eslint-disable-next-line prefer-reflect
      tl.call(() => this._showContent(index), null, `+=${duration}`);
    });
  }

  _showContent(activeIndex) {
    // Met à jour les images
    this.contentImages.forEach((image, index) => {
      image.style.opacity = index === activeIndex ? 1 : 0;
    });

    // Met à jour les titres
    this.contentTitle.forEach((title, index) => {
      title.style.display = index === activeIndex ? 'block' : 'none';
    });

    // Met à jour les textes
    this.contentText.forEach((text, index) => {
      text.style.display = index === activeIndex ? 'block' : 'none';
    });

    // Met à jour les liens (ajout de la classe active)
    this.contentLinks.forEach((link, index) => {
      if (index === activeIndex) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  events() {
    if (!this.contentLinks) return;

    this.contentLinks.forEach((link, indexLink) => {
      link.addEventListener('mouseenter', () => {
        this._showContent(indexLink);
      });
    });
  }
}
